<template>
  <div class="home">
    <div class="wrap">   
      <div class="sign" id="sign">
        <div class="sTitle">
          注册
        </div>
        <div class = "sign-body">
          <div id = "signUp" class="s-form" >
            <form @submit.prevent="" v-show="step1">
              <label>手机号</label>
              <div class="field">  
                <input v-model="newUser.phone" name="name" type="text" ref="phone">
                <div class="warning" v-show="warnPhone" ref="warn"></div>
              </div>          
              <label for="">验证码</label> 
              <div class="field" style="display:flex;margin-bottom:0">
                <input v-model="newUser.vertify" name="name" type="text" style="flex:1;margin-right:5px" ref="vertify">
                <button class="btn-code" v-show="!hasCounted" @click="getVertifyCode" ref="getVCode">获取验证码</button>
                <button class="btn-count" v-show="hasCounted">{{count}}秒后重新发送</button>                
              </div>
              <div class="warning" v-show="vertifyTip" ref="vertifyTip"></div>
              <button class="btn btn-primary" @click="nextStep">下一步</button> 
            </form>

            <form @submit.prevent="signUp">
              <div v-show="step2">
                <label for="">密码</label>
                <div class="field">
                    <input v-model="newUser.password" name="name" type="text">
                    <div ref="passwordTip" class="warning"></div>
                </div>
                <div id="signUp">
                  <input class="btn" style="margin-bottom:6px" type="submit" value="注册">
                  <p v-show="regSuccess">注册成功!</p>
                </div>    
              </div>
            </form>
            <router-link class="rtSignUp" to='/home'>
              登录
            </router-link>              
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajaxAPI } from '@/utils/ajaxUtil'
import { HYBIRD_URL } from '@/config/url_config'
export default {
  components: {
  },
  data () {
    return {
      user: {
        userName: 'jfsun@kaikeba.com',
        password: '123456'
      },
      newUser: {
        phone: '',
        password: '',
        vertify: ''
      },
      n: 0,
      isSign: 0,
      count: 60,
      hasCounted: false,
      step1: true,
      step2: false,
      warnPhone: false,
      vertifyTip: false,
      warnSigned: false,
      regSuccess: false,
      items: [
        {identity: '老师'},
        {identity: '学生'}
      ],
      roomId: ''
    }
  },
  mounted () {
  },
  methods: {
    register () {
      this.isSign = 1
      document.getElementById('sign').style.height = '460px'
    },
    getVertifyCode () {
      let signUpData = this.newUser
      let _this = this
      _this.count = 60      // 每次倒计时之前需要重置
      let url = `${HYBIRD_URL}/user/getPhoneSMSCode?mobile=${signUpData.phone}`
      _this.vertifyTip = false
      _this.warnPhone = false
      _this.$refs.getVCode.setAttribute('disabled', true)
      console.log('00000')
      if (!signUpData.phone) {
        _this.warnPhone = true
        _this.$refs.warn.innerHTML = '请输入手机号码'
        return false
      }
      if (!(/^1(3|4|5|7|8)\d{9}$/.test(signUpData.phone))) {
        _this.warnPhone = true
        _this.$refs.warn.innerHTML = '请输入正确的手机号码'
        return false
      }
      ajaxAPI('GET', url).then(data => {
        // console.log(data)
        _this.warnPhone = false
        if (data.data.status === '0') {
          _this.hasCounted = true
          _this.countdown = setInterval(function () {
            console.log(_this.count)
            _this.count--
            if (_this.count === 0) {
              clearInterval(_this.countdown)
              _this.hasCounted = false
              _this.$refs.getVCode.innerHTML = '再次发送'
              _this.$refs.getVCode.removeAttribute('disabled')
            } else {
              _this.hasCounted = true
            }
          }, 1000)
        } else {
          _this.warnPhone = true
          _this.hasCounted = false
          _this.$refs.warn.innerHTML = data.data.message
        }
      }).catch(error => {
        console.log(error)
      })
    },
    nextStep () {
      let url = `${HYBIRD_URL}/user/verifySmsCode`
      let data = {
        mobile: this.newUser.phone,
        validateCode: this.newUser.vertify
      }
      this.warnPhone = false
      this.vertifyTip = false
      console.log('data', data)
      if (!this.newUser.phone) {
        this.warnPhone = true
        this.$refs.warn.innerHTML = '请输入手机号码'
        return false
      }
      if (!this.newUser.vertify) {
        this.warnPhone = false
        this.vertifyTip = true
        this.$refs.vertifyTip.innerHTML = '请输入验证码'
        return false
      }
      ajaxAPI('POST', url, data).then(data => {
        console.log(data)
        if (data.data.status === '0') {
          this.step1 = false
          this.step2 = true
          clearInterval(this.countdown)
        } else {
          this.vertifyTip = true
          this.$refs.vertifyTip.innerHTML = '请输入正确的验证码'
          console.log(data.data.message)
          this.$refs.tipCode.innerHTML = data.data.message
        }
      }).catch(error => {
        console.log(error)
      })
    },
    signUp () {
      let _this = this
      let signUpData = {
        mobile: _this.newUser.phone,
        password: _this.newUser.password
      }
      let url = `${HYBIRD_URL}/user/register`
      if (!signUpData.password) {
        this.$refs.passwordTip.innerHTML = '密码不能为空!'
        return false
      }
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(signUpData.password)) {
        this.$refs.passwordTip.innerHTML = '密码必须由数字和字母组成!且长度为6-16位'
        return false
      }
      console.log(signUpData)
      ajaxAPI('POST', url, signUpData).then(data => {
        console.log(data)
        if (data.data.status === '0') {
          _this.regSuccess = true
          _this.$refs.passwordTip.innerHTML = ''
          setTimeout(function () {
            _this.$router.push('home')
          }, 2000)
        }
      }).then(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
  input{
    outline: 0
  }
  .home{
    text-align: center;
    color:#8B9194;  
  }
  .btn-count{
    width:140px;
    height:34px;
    border-radius:20px;
    background:#1FB6FF;
    color:#fff;
    border:0;
    position: relative;
  }
  .btn-code{
    border:0;
    background:#fff;
    color:#1FB6FF;
  }    
  .sTitle{
    font-size: 16px;
    font-weight: normal;
    line-height: 60px;
    border-bottom: 1px solid rgba(209, 211, 212, .4);
    letter-spacing: 8px;
  }
</style>



// WEBPACK FOOTER //
// signup.vue?7cf48531